import { KLineData } from "klinecharts";
import { readStyle } from "./indicatorUtils";

export const createFractals = (settings: any) => {
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const upS = readStyle(styles, "upFractal", "#26A69A");
  const downS = readStyle(styles, "downFractal", "#EF5350");

  return {
    name: "fractals",
    shortName: "Fractals",
    calcParams: [] as number[],
    series: "price" as const,
    figures: [
      { key: "upFractal", title: "Up: ", type: "text" },
      { key: "downFractal", title: "Down: ", type: "text" },
    ],
    styles: {
      texts: [
        { color: upS.color, size: 10 },
        { color: downS.color, size: 10 },
      ],
    },
    regenerateFigures: () => [
      { key: "upFractal", title: "Up: ", type: "text" },
      { key: "downFractal", title: "Down: ", type: "text" },
    ],
    calc: (dataList: KLineData[]) => {
      const n = dataList.length;
      const results: Array<{
        upFractal?: number;
        downFractal?: number;
      }> = new Array(n);

      for (let i = 0; i < n; i++) {
        results[i] = {};
        if (i < 2 || i >= n - 2) continue;

        const h0 = dataList[i - 2]!.high;
        const h1 = dataList[i - 1]!.high;
        const h2 = dataList[i]!.high;
        const h3 = dataList[i + 1]!.high;
        const h4 = dataList[i + 2]!.high;
        const l0 = dataList[i - 2]!.low;
        const l1 = dataList[i - 1]!.low;
        const l2 = dataList[i]!.low;
        const l3 = dataList[i + 1]!.low;
        const l4 = dataList[i + 2]!.low;

        if (h2 > h0 && h2 > h1 && h2 > h3 && h2 > h4) {
          results[i]!.upFractal = h2;
        }
        if (l2 < l0 && l2 < l1 && l2 < l3 && l2 < l4) {
          results[i]!.downFractal = l2;
        }
      }

      return results;
    },
  };
};
